import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { format } from "date-fns";

const initialState = {
    dueDate: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
    isDirty: false,
    locationValue: "",
    carrier: "",
    carrierTrackingNumbers: [],
    client: "",
    cxHCompany: "",
    createdBy: "",
    createdOn: "",
    dueOn: "",
    finalDestination: "",
    finalDestinationContact: "",
    hasMetricMeasurementsOnly: false,
    hasPremiumEditingShipmentDefault: false,
    sendToGdsn: false,
    isFoodService: false,
    holdReleaseDate: "",
    holdReleasedOnDate: null,
    imagesNeedClientApprovalDefault: false,
    isCmp: false,
    isCmpConfirmed: false,
    isCompleted: false,
    isMasterDataSolution: false,
    isMissingPaperwork: false,
    isMissingPayment: false,
    isMissingReturnDate: false,
    isOnHold: false,
    isPerishable: false,
    isRush: false,
    key: "",
    legacyItemMasterShipmentTypeId: "",
    paymentMethod: "",
    paymentReferenceNumber: "",
    receivedBy: "",
    receivedByMatch: {},
    receivedOn: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
    startDate: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
    rushDays: "",
    rushConfirmedBy: "",
    supplier: "",
    turnAroundDays: "",
    updatedBy: "",
    updatedOn: "",
};

const reducer = (state, action) => {
    switch (action.type) {
        case "UPDATE_STATE":
            return {
                ...state,
                isDirty: true,
                [action.key]: action.value,
                ...action.additionalChanges,
            };
        case "UPDATE_DATES":
            return {
                ...state,
                ...action.additionalChanges,
            };
        case "SAVED":
            return {
                ...state,
                isDirty: false,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
